module.exports = __webpack_public_path__ + "3d12a8ba26a289fc251a43fb19502d69.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/trickstrat/playbook.png
// module id = 246
// module chunks = 0